"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../src/utils/constants");
const types_1 = require("../../src/utils/types");
const naked_1 = require("../../src/naked");
const conditions_1 = require("../../src/utils/Conditions/conditions");
const SL_MODULE_CONFIG = {
    addonFeatureRegistry: {},
    sections: [
        {
            name: "section1",
            cardSelector: ".product__container",
            featureConfigs: [
                {
                    kind: "DynamicButtonsFeature",
                    templateSelector: ".product__info__container",
                    originalButtonConfig: [types_1.OriginalMode.NO_ACTION],
                    maxLinksPerCard: 3,
                    originalButton: {
                        anchorInnerTemplate: "{{currency}}{{currentPriceWithoutCurrency}} at {{merchantName}}",
                    },
                    alternativeButton: {
                        template: `<div class="ParagraphProductstyles__ParagraphProductCtaBtnContainer-sc-5cswrk-14 bJtiNU product__button tbl-alternative-btn-wrapper">\n
                        <button type="button" class="Buttonstyles__ButtonContainer-sc-1e79xnn-0 kTSUqQ cta-button">\n
                          <a href="{{url}}" target="_blank">
                            <div class="Buttonstyles__ButtonContent-sc-1e79xnn-1 gNrWRE ButtonContent">\n
                              <div class="Buttonstyles__ButtonText-sc-1e79xnn-2 aIdks ButtonText">{{currency}}{{currentPriceWithoutCurrency}} at {{merchantName}}</div>\n
                            </div>
                          </a>
                        </button>
                        <div class="tbl-container-for-same-width"></div>
                      </div>`,
                    },
                    onDomChanged: (newHTMLElement, mode, productDetails) => {
                        if (mode !== types_1.ButtonMode.ALTERNATIVE)
                            return;
                        newHTMLElement.onclick = () => {
                            let discount = 0;
                            if (productDetails.price && productDetails.original_price) {
                                discount = productDetails.original_price - productDetails.price;
                            }
                            window.dataLayer.push({
                                event: "select_item",
                                ecommerce: {
                                    item_list_id: null,
                                    item_list_name: null,
                                    items: [
                                        {
                                            item_name: productDetails.product_name,
                                            item_id: productDetails.sku,
                                            item_brand: productDetails.product_brand,
                                            price: addDollarSign(roundingNumbersWithTwoDecimals(productDetails.price ?? productDetails.original_price ?? 0)),
                                            discount: addDollarSign(absoluteValue(roundingNumbersWithTwoDecimals(discount))),
                                            item_category: "Skimlinks",
                                            item_category2: productDetails.merchant_name,
                                            item_list_id: null,
                                            item_list_name: null,
                                            item_variant: "product card - button - skim",
                                            affiliation: productDetails.urls.affiliated_url,
                                        },
                                    ],
                                },
                            });
                        };
                    },
                    onButtonVisible: (newHTMLElement, mode, productDetails) => {
                        if (mode !== types_1.ButtonMode.ALTERNATIVE)
                            return;
                        let discount = 0;
                        window.dataLayer.push({
                            event: "view_item",
                            ecommerce: {
                                item_list_id: null,
                                item_list_name: null,
                                items: [
                                    {
                                        item_name: productDetails.product_name,
                                        item_id: productDetails.sku,
                                        item_brand: productDetails.product_brand,
                                        price: addDollarSign(roundingNumbersWithTwoDecimals(productDetails.price ?? productDetails.original_price ?? 0)),
                                        discount: addDollarSign(absoluteValue(roundingNumbersWithTwoDecimals(discount))),
                                        item_category: "Skimlinks",
                                        item_category2: productDetails.merchant_name,
                                        item_list_id: null,
                                        item_list_name: null,
                                        item_variant: "product card - button - skim",
                                        affiliation: productDetails.urls.affiliated_url,
                                    },
                                ],
                            },
                        });
                    },
                    domainBlacklist: ["howl.me", "nordstrom.sjv.io", "gap.igs4ds.net"],
                    skipButtonClasses: [constants_1.defaultSkipButtonSelector],
                    validateProduct: (productDetails) => {
                        if (productDetails.currency === "USD") {
                            return [true, [""]];
                        }
                        else {
                            return [false, [`Product's currency ${productDetails.currency} is not matching the required currency USD.`]];
                        }
                    },
                },
                {
                    kind: "StyleInjectionFeature",
                    className: "product-card__affiliate-temporary-column",
                    tempStyle: `
            .product__container {
              display: grid;
              grid-template-columns: 180px auto;
            }

            .dIiaLu {
              grid-column: 1 / 2;
              grid-row: 1 / 5;
            }

            .product__info__container,
            .tbl-alternative-btn-wrapper {
              grid-column: 2 / 3;
            }

            .product__button {
              padding-left: 10px;
            }

            .product__button button {
              max-width: 100%;
              margin-top: 8px;
              width: 275px;
            }

            .product__button button > a {
              width: 100%;
            }

            .product__button .ButtonText {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .product__button button > a:not(.has-image),
            .product__button button > a:hover:not(.has-image) {
              border-bottom: none;
            }

            .product__button button > a:hover:not(.has-image) {
              color: rgb(199, 222, 254);
            }

            @media (max-width: 768px) {
              .tbl-alternative-btn-wrapper {
                display: flex;
                justify-content: center;
              }
              .product__container {
                display: block;
              }

              .product__button button {
                padding: 8px 20px;
              }

              .tbl-container-for-same-width {
                width: 0;
              }
            }
          `,
                },
            ],
        },
    ],
    skimlinksPublisherId: 1025,
    skimlinksPublisherDomainId: 1701743,
    oldSkimlinksRequestUrl: "https://products.skimlinks.com/v1/publisher/1025/multi-products",
    skimlinksRequestUrl: "https://products.skimlinks.com/v1/publisher/1025/cards",
    oldSkimlinksRequestUrlParams: [
        { key: "publisher_domain_id", value: 1701743 },
        { key: "per_merchant_limit", value: 1 },
        { key: "alternatives_size", value: 5 },
        { key: "alternative_country_code", value: "US" },
        { key: "country_code", value: "US" },
        { key: "merchant_type", value: "featured" },
        { key: "exclude_domains", value: "steepandcheap.com|ebay.com" },
    ],
    skimlinksRequestUrlParams: [
        { key: "publisher_domain_id", value: 1701743 },
        { key: "per_merchant_limit", value: 1 },
        { key: "alternatives_size", value: 5 },
        { key: "alternative_country_code", value: "US" },
        { key: "country_code", value: "US" },
        { key: "merchant_type", value: "featured" },
        { key: "disable_geo", value: "true" },
        { key: "exclude_domains", value: "steepandcheap.com|ebay.com|amazon.com|amazon.co.uk|stockx.com|grailed.com|thredup.com" },
    ],
    useNewProductApi: true,
    priceFormat: {
        locale: "en-US",
        decimalNumberFormat: {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        },
    },
    skipCardSelector: constants_1.defaultSkipCardSelector,
    runModeConditions: {
        preconditions: [[(0, conditions_1.not)((0, conditions_1.matchPaths)("", "/", "/home"))]],
        isProduction: [
            [() => window._tblGravity.forcedProduction === true, (0, conditions_1.not)((0, conditions_1.hasDomElement)(".sponsored-presented"))],
            [
                (0, conditions_1.matchPaths)("/pets/trolls-halloween-costume-dogs-42486338", "/fitness/forme-power-sports-bra-review-49329520", "/fashion/best-women-sneakers-44311634", "/fashion/david-rose-sweaters-schitts-creek-47231713", "/fashion/best-cashmere-loungewear-47945465", "/shopping/best-gifts-taylor-swift-fans-36131679", "/beauty/bath-body-works-halloween-collection-48425632", "/fitness/merrell-agility-peak-5-review-49390508", "/fitness/vs-pink-relay-activewear-review-49389377", "/family/best-teen-gifts-from-amazon-46828664", "/smart-living/best-products-on-sale-at-bed-bath-beyond-48122262", "/fashion/most-comfortable-work-shoes-for-women-47228465", "/fitness/best-one-piece-workout-bodysuits-for-women-48188633", "/shopping/gifts-women-30s-25946384", "/fitness/best-workout-dresses-48251340", "/travel/best-personal-item-carry-on-bags-flying-48891209", "/beauty/taylor-swift-red-lipstick-48605055", "/tech/best-apple-watch-bands-for-women-48674795", "/tech/tech-gifts-men-36026397", "/smart-living/gifts-travelers-45429515", "shopping/holiday-gift-guide-49277906", "/shopping/cheap-gifts-teens-36084638", "/fitness/leggings-make-your-butt-look-good-44234490", "/shopping/gifts-women-20s-25897406", "/shopping/what-to-wear-to-sabrina-carpenter-concert-49385129", "/fashion/what-to-wear-to-taylor-swift-concert-49123496"),
            ],
            // [ testPath(new RegExp("\/family\/.+") ],
            // [ () => window.location.pathname.startsWith("/family/") ],
        ],
        isSilent: [[(0, conditions_1.hasDomElement)(".product__container")]],
    },
};
const configBag = {
    default: SL_MODULE_CONFIG,
};
const roundingNumbersWithTwoDecimals = (number) => {
    return Math.round(number * 100) / 100;
};
const addDollarSign = (price) => {
    return `$${price}`;
};
const absoluteValue = (price) => {
    return Math.abs(price);
};
(0, naked_1.init)(configBag);
window._tblGravity.tblSLLinksAndButtonsInit();
